






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { ICompany, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'company',
  }),
  mixins: [paginationMixin],
})
export default class CompanyList extends Vue {
  @Action('getEntities', { namespace: 'company' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'company' })
  entitiesSlice: ICompany[];
  @State('pageParams', { namespace: 'company' })
  pageParams: IPageParams;
  interval = null;
  headers = [
    { text: 'Название', value: 'name' },
    { text: 'Тип', value: 'company_type.name' },
  ];
  selected = [];
  created() {
    this.getEntities();
  }
}
